<template>
  <v-dialog
    v-model="show"
    width="40vw"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    scrollable
    persistent
  >
    <v-card height="auto" elevation="5" class="rounded-lg" min-height="200">
      <v-card-title class="text-h5 lighten-2">Desechar caja/tubo</v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col>
                <v-col cols="12">
                  <v-autocomplete
                    outlined
                    :search-input.sync="search"
                    item-text="serialReactivation"
                    label="Selecciona reactivacion"
                    return-object
                    clearable
                    no-data-text="No se encontro reactivación"
                    :loading="isLoadingReactivation"
                    v-model="reactivationsSelected"
                    @keydown="cleanOldValue"
                    :items="reactivations"
                    dense
                    :multiple="true"
                    chips
                    :rules="validationMultiple()"
                  ></v-autocomplete>
                </v-col>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <v-row>
            <v-col>
              <v-btn
                color="red"
                block
                @click="show = false"
                dark
                :disabled="isLoading"
                >Cancelar</v-btn
              >
            </v-col>
            <v-col>
              <v-btn
                color="primary"
                block
                @click="discardReactivations"
                :loading="isLoading"
                >Aceptar</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
//vuex
import { mapActions, mapMutations } from "vuex";
//axios
import axios from "axios";
//validations
import { requiredValidation, requiredMultiple } from "@/helpers/validations.js";

export default {
  data: () => ({
    isLoading: false,
    isLoadingReactivation: false,
    reactivationsSelected: [],
    search: null,
    reactivations: [],
    user: JSON.parse(localStorage.getItem("user")),
  }),
  props: {
    value: Boolean,
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    ...mapActions("bioactives", ["searchReactivation"]),
    ...mapActions("lotes", ["discardReactivationsUnused"]),
    ...mapMutations(["SET_CANCEL_TOKEN"]),
    cleanOldValue() {
      if (!this.search) {
        this.reactivation = null;
      }
    },
    validation(name) {
      return requiredValidation(name);
    },
    validationMultiple(name) {
      return requiredMultiple(name);
    },
    async discardReactivations() {
      if (this.$refs.form.validate()) {
        try {
          this.isLoading = true;
          let reactivations = [];
          for (let item of this.reactivationsSelected) {
            reactivations.push(item._id);
          }
          let payload = {
            reactivations: reactivations,
          };
          let response = await this.discardReactivationsUnused(payload);
          if (!response) throw response;
          this.$swal({
            icon: "success",
            title: `Caja(s)/Tubo(s) desechados correctamente`,
            showConfirmButton: false,
            timer: 2000,
          });
          this.show = false;
        } catch (error) {
          console.log(error);
          this.$swal({
            icon: "error",
            title: `Algo salio mal al desechar: ${error.message}`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
        this.isLoading = false;
      }
    },
  },
  watch: {
    async search(value) {
      if (!value) return;
      else {
        this.isLoadingReactivation = true;

        if (typeof this.cancelToken != typeof undefined) {
          this.cancelToken.cancel("Operation canceled due to new request.");
        }

        //Save the cancel token for the current request
        this.SET_CANCEL_TOKEN(axios.CancelToken.source());
        try {
          const response = await this.searchReactivation({
            identification: value,
          });
          if (response.error) throw response;

          this.reactivations = response.reactivationsFound;
        } catch (e) {
          console.log(e);
        }
        this.isLoadingReactivation = false;
      }
    },
  },
};
</script>
